import { PromotionResult } from '@model/product/Product';


export const getPromotionDF = (promotionResults: PromotionResult[]): string => {
  const promotionDF = (promotionResults || []).find((promo) => promo.orderTotalCode === 'ot_df_product_discount');
  return promotionDF ? 'w2.product.tile.price.set' : 'w2.product.tile.price.normal';
};


